import RelativeDate from './RelativeDate';

export default RelativeDate;
